<template>
	<Modal title="Game settings">
		<div class="form-group row">
			<label
				for="version"
				class="col-sm-4 col-form-label"
			>Game version</label>
			<div class="col">
				<select
					:disabled="loading"
					class="form-control"
					id="version"
					v-model="version"
				>
					<option
						v-for="option in versions"
						:key="option.value"
						:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<div class="form-group row">
			<label
				for="boardSize"
				class="col-sm-4 col-form-label"
			>Board size</label>
			<div class="col">
				<select
					:disabled="loading"
					class="form-control"
					id="boardSize"
					v-model="boardSize"
				>
					<option
						v-for="option in boardSizes"
						:key="option.value"
						:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<div class="form-group row">
			<label
				for="mode"
				class="col-sm-4 col-form-label"
			>Game type</label>
			<div class="col">
				<select
					:disabled="loading || version == 'pc2v0_0'"
					class="form-control"
					id="mode"
					v-model="mode"
				>
					<option
						v-for="option in modes"
						:key="option.value"
						:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<div class="form-group row" v-if="version != 'pc2v0_0'">
			<label
				for="level"
				class="col-sm-4 col-form-label"
			>Level</label>
			<div class="col">
				<select
					:disabled="loading"
					class="form-control"
					id="level"
					v-model="level"
				>
					<option
						v-for="option in levels"
						:key="option.value"
						:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<div class="form-group row" v-if="version != 'pc2v0_0'">
			<label
				for="maxCaptives"
				class="col-sm-4 col-form-label"
			>Max. captives</label>
			<div class="col">
				<select
					:disabled="loading"
					class="form-control"
					id="maxCaptives"
					v-model="limit"
				>
					<option
						v-for="option in limits"
						:key="option.value"
						:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<template v-slot:footer>
			<button
				class="btn btn-light"
				:disabled="loading"
				@click="loadDefaults"
			>Load defaults</button>
			<button
				class="btn btn-light"
				:disabled="loading"
				@click="save"
			>Save</button>
		</template>
	</Modal>
</template>

<script>
import HH from "../logic/logic";
import HHUI from "../logic/ui";
import HHServer from "../logic/server";

export default {
	data() {
		return {
			loading: true,
			version: null,
			versions: [],
			boardSize: null,
			boardSizes: [],
			mode: null,
			modes: [],
			level: null,
			levels: [],
			limit: null,
			limits: []
		};
	},
	computed: {
		settings() {
			return {
				version: this.version,
				mode: this.mode,
				width: this.boardSize,
				height: this.boardSize,
				level: this.level,
				limit: this.limit
			};
		}
	},
	watch: {
		version(v) {
			if (v == 'pc2v0_0') this.mode = 'TABLET';
		}
	},
	methods: {
		async load() {
			let r = await fetch("settings.json");
			const settings = await r.json();

			function selected(arr) {
				const selecteds = arr.filter(o => o.selected);
				return selecteds.length > 0 ? selecteds[0].value : null;
			}

			this.versions = settings.versions;
			this.version = selected(settings.versions);

			this.boardSizes = settings.boardSizes;
			this.boardSize = selected(settings.boardSizes);

			this.modes = settings.modes;
			this.mode = selected(settings.modes);

			this.levels = settings.levels;
			this.level = selected(settings.levels);

			this.limits = settings.limits;
			this.limit = selected(settings.limits);

			if (!HH.settings && window.localStorage.hhSettings) {
				HH.settings = JSON.parse(window.localStorage.hhSettings);
			}

			if (HH.settings) {
				this.version = HH.settings.version;
				this.boardSize = HH.settings.width; // !
				this.mode = HH.settings.mode;
				this.level = HH.settings.level;
				this.limit = HH.settings.limit;
			}
		},
		async loadDefaults() {
			delete window.localStorage.hhSettings;
			HH.settings = null;
			await this.load();
		},
		async save() {
			this.loading = true;
			try {
				await HHServer.changeSetting(this.settings);
				window.localStorage.hhSettings = JSON.stringify(this.settings);
				HH.settings = this.settings;
				this.loading = false;
				this.$emit("loaded", this.settings);
			} catch (e) {
				HHUI.error(e);
			}
		}
	},
	async created() {
		try {
			// create session + load default config + load previous config if any
			await Promise.all([this.load(), HHServer.createSessionManager()]);
			// set config in session
			await this.save();
		} catch (e) {
			HHUI.error(e);
		}
	}
};
</script>